<template>
  <!-- begin widget-chat -->
  <div class="widget-chat rounded mt-3">
    <!-- begin widget-chat-header -->
    <div class="widget-chat-header">
      <div class="widget-chat-header-icon">
        <i class="fas fa-message bg-white-600 w-30px h-30px fs-20px text-dark text-center rounded-pill"
          style="line-height: 30px"></i>
      </div>
      <div class="widget-chat-header-content">
        <h4 class="widget-chat-header-title">Модератор</h4>
        <p class="widget-chat-header-desc">Результаты проверки Вашего задания:
        </p>
      </div>
    </div>
    <!-- end widget-chat-header -->

    <!-- begin widget-chat-body -->
    <div class="widget-chat-body" data-scrollbar="true" data-height="235px">
      <!--<div class="text-center text-gray-500 m-3 fw-bold">Today</div>-->
      <div v-show="!task.reviews.length" class="text-center">Ваше задание активно, замечаний к заданию нет.</div>
      <div class="widget-chat-item with-media" v-for="(item, index)  in task.reviews" :key="index">
        <div class="widget-chat-media">
          <img onerror="javascript:this.src='/assets/img/user/user-5.jpg'" alt=""
            :src="`/images/avatar/${item.user.avatar}`" class="user-avatar" width="50" height="50" />
        </div>
        <div class="widget-chat-info">
          <div class="widget-chat-info-container">
            <div class="widget-chat-name text-indigo"> {{ item.user.name }}</div>
            <div class="widget-chat-message pre-formatted">
              <div v-html="addTagsToLinks(item.message)"></div>
            </div>
            <div class="widget-chat-time">{{ item.created_at }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end widget-chat-body -->

    <!-- begin widget-input -->
    <div v-if="user.id == 1" class="widget-input">
      <form action="" method="POST" name="">
        <div class="d-flex flex-column">
          <div class="d-flex justify-content-start ms-2">
            <div v-for="(image, index)  in images" :key=index class="imageWrapper me-1 mt-2 mb-2"
              :style="{ 'background-image': `url(${image})` }" style="width: 100px;height: 100px;">
              <div class="d-flex justify-content-end">
                <a @click="removeImage(index)" class="btn  btn-icon btn-circle btn-danger">
                  <i class="fa fa-times"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="m-2">
            <validation-observer ref="form">
              <validation-provider #default="{ errors }" name="message" rules="min:0|max:5120" vid="message">
                <textarea v-model="message" class="form-control" rows="6"></textarea>
                <small v-show="!errors[0]">Опишите как именно нужно доработать задание</small>
                <small class="text-danger">{{ errors[0] }}</small>

              </validation-provider>
            </validation-observer>
          </div>

          <div class="d-flex justify-content-end ms-2 me-2 mb-2">
            <div class="d-flex justify-content-between me-2 mb-2">
              <div class="me-2">
                <select v-model="status" class="form-select ">
                  <option v-for="(status, index)  in statuses" :key=index :value="status.name">
                    {{ status.desc }}
                  </option>
                </select>
              </div>
              <div class="btn btn-primary w-100px" @click="checkForm()"> <i v-show="loading"
                  class="fas fa-circle-notch fa-spin"></i>
                <span v-show="!loading"> Ответить</span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- end widget-input -->
  </div>
  <!-- end widget-chat -->
</template>

<script>
import HTTP from "../http";
import {show_error} from "../message";
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';
extend('required', required);

export default {

  name: 'ModChat',
  props: ['job', 'task'],
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      loading: false,
      message: "",
      status: 'REVIEW',
      previewImage: null,
      images: [],
      files: [],
      user: {},
      statuses: []
    }
  },

  mounted() {
    console.log('job', this.job)
    this.user = JSON.parse(localStorage.getItem('user'))
    this.statuses = [
      {name: "PROGRESS", desc: 'Принято'},
      {name: "REJECTED", desc: 'Требуется доработка'},
      {name: "CANCELED", desc: 'Бан'},
    ]
    this.status = "PROGRESS"
  },



  methods: {
    isUrlValid(str) {
      let url;
      try {
        url = new URL(str);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    },
    stringToUrl(str) {
      return this.isUrlValid(str) ? `<a target="_blank" href="${str}">${str}</a>` : str
    },
    addTagsToLinks(str) {
      str = str.replace(/(<([^>]+)>)/ig, '')
      let lines = str.split(/\r?\n/)
      lines = lines.map(x => x.split(' ').reduce((accumulator, currentValue) => accumulator + ' ' + this.stringToUrl(currentValue), ''))

      return lines.reduce((accumulator, currentValue) => accumulator + '\r\n' + this.stringToUrl(currentValue))
    },
    checkForm() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }
        this.reviewCreate(this.status)
      })
    },

    reviewCreate(status) {
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .post(`/review`, {task_id: this.task.id, status, message: this.message})
        .then((resp) => {
          console.log('resp', resp)
          this.message = ''
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
          window.eventBus.$emit('admin.chat.update', this.task.id)
        });
    },
  }
}
</script>


